module.exports = __webpack_public_path__ + "img/P150T_weapon_148.65eb4b8d.png";